import { FC } from 'react';

import { cn } from 'utils/helpers';

import Button from '../Button';

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
};

const ExportDataModal: FC<Props> = ({ onCancel, onConfirm }) => {
  return (
    <div>
      <div className="text-sm font-semibold leading-[22px] tracking-wider mb-2">
        The file will be exported
      </div>
      <div className="text-xs">
        <p>
          You will receive a notification via email and in your notification
          center once it is ready for download.
        </p>
        <br />
        <p>Do you wish to proceed?</p>
      </div>
      <div
        className={cn(
          'flex justify-end gap-3',
          'px-2.5 pt-5 mt-5',
          'border-t-[0.5px] border-separator-primary',
        )}
      >
        <Button onClick={onConfirm} type="button" label="YES" size="sm" />
        <Button onClick={onCancel} label="NO" size="sm" intent="tertiary" />
      </div>
    </div>
  );
};

export default ExportDataModal;
